













import { defineComponent, reactive, onBeforeMount } from '@vue/composition-api'

import { ReceiptState, UserState } from '@/types/store'
import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { ReceiptsTable } from '@/components/organisms/shop-unchecked-receipts'

export default defineComponent({
  name: 'UncheckedReceipts',
  components: { Layout, ReceiptsTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      receipts: useVuex<ReceiptState['receipts']>(
        context,
        () => store.getters['receipt/receipts'],
      ),
      total: useVuex<ReceiptState['total']>(
        context,
        () => store.getters['receipt/total'],
      ),
      isReceiptsLoading: useVuex<ReceiptState['isReceiptsLoading']>(
        context,
        () => store.getters['receipt/isReceiptsLoading'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })
    onBeforeMount(async () => {
      store.dispatch('receipt/getShopUncheckedReceipts')
    })

    return { state }
  },
})
